// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__XAD95","detailsBorder":"styles_detailsBorder__12zJH"};